import React from "react";
import { Box } from "@mui/material";
import { Quantity } from "../../models/models";
import QuantityFormat from "./QuantityFormat";

export interface LimitedQuantityFormatProps {
  value?: Quantity | null;
  limit?: Quantity | null;
}

const LimitedQuantityFormat = ({ value, limit }: LimitedQuantityFormatProps) => {
  return (
    <>
      <QuantityFormat value={value} />
      {!!limit && (
        <>
          <Box component="span" className="text-14-medium" color="#22242D">
            &nbsp;/&nbsp;
          </Box>
          <QuantityFormat value={limit} />
        </>
      )}
    </>
  );
};

export default LimitedQuantityFormat;